import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ProgressIndicatorService } from '@libs/services/progress-indicator.service';
import { FeedbackWithGoHomeComponent } from '../../components/feedback-with-go-home/feedback-with-go-home.component';

@Component({
  selector: 'app-temporarily-unavailable',
  imports: [CommonModule, FeedbackWithGoHomeComponent],
  templateUrl: './temporarily-unavailable.component.html',
  styleUrl: './temporarily-unavailable.component.scss',
})
export class TemporarilyUnavailableComponent {
  progressIndicatorService = inject(ProgressIndicatorService);
  constructor() {
    this.progressIndicatorService.isProgressIndicator.set(false);
    this.progressIndicatorService.progressIndicatorMessage.set('');
  }
}
